<div class="modal-header detail-controle-header">
  <div class="header-title">
    <h4 class="modal-title mb-1">
      <span translate [translateParams]="{ annee: annee }">
        page.declarations.detail-controle.title
      </span>
    </h4>

    <div class="text-muted operator-line">
      <strong>{{ operateur?.raisonSociale }}</strong>
      <span *ngIf="cvi"> — {{ cvi }}</span>
    </div>
  </div>

  <button
    type="button"
    class="btn-close"
    aria-label="Fermer"
    (click)="onClose()">
  </button>
</div>

<div class="modal-body">

 
  <!-- Synthèse visuelle -->
<section class="synthese-chart-panel mb-4" *ngIf="syntheses?.length > 0">

  <div class="synthese-chart-header">
    <div>
      <div class="synthese-title">
        Synthèse des 3 dernières années
      </div>
      <div class="synthese-subtitle">
        Volumes déclarés, volumes contrôlés, lots déclarés et lots contrôlés
      </div>
    </div>
  </div>

  <div
    echarts
    [options]="syntheseChartOption"
    class="synthese-chart">
  </div>
<div class="chart-help-text">
  Survolez une année pour afficher le détail par type de déclaration et cahier des charges.
</div>
</section>


  <!-- Liste des contrôles -->
  <section>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="section-title">
        <fa-icon icon="clipboard-check" class="me-2"></fa-icon>
        <span translate>page.declarations.detail-controle.controlesAnnee</span>
      </div>

      <span class="badge bg-secondary" *ngIf="controles?.length">
        {{ controles.length }} contrôle(s)
      </span>
    </div>

    <div class="table-responsive" *ngIf="controles?.length > 0; else aucunControle">
      <table class="table table-hover align-middle controle-table" aria-label="Liste des contrôles">
        <thead class="table-light">
          <tr>
            <th translate>page.declarations.detail-controle.table.header.produit</th>
            <th translate>page.declarations.detail-controle.table.header.millesime</th>
            <th translate>page.declarations.detail-controle.table.header.mvt</th>
            <th class="text-end" translate>page.declarations.detail-controle.table.header.volume</th>
            <th translate>page.declarations.detail-controle.table.header.date</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let controle of controles">
            <td>
              <strong>{{ controle.libelleProduit }}</strong>
            </td>

            <td>
              <span class="badge bg-light text-dark border">
                {{ controle.millesime || '—' }}
              </span>
            </td>

            <td>{{ controle.libelleMouvement }}</td>

            <td class="text-end">
              {{ controle.volume | number:'1.0-2' }}
            </td>

            <td>
              {{ controle.dateControle | date:'dd/MM/yyyy' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

</div>

<ng-template #aucunControle>
  <div class="empty-state">
    <fa-icon icon="circle-info" class="empty-icon"></fa-icon>
    <div class="empty-title" translate>
      page.declarations.detail-controle.aucunControle
    </div>
  </div>
</ng-template>